// Restores the query-string serialization axios used before the 0.16 -> 1.x upgrade.
//
// axios 1.x changed how it serialises request `params`: a nested object that axios 0.x turned
// into a JSON string (e.g. `q={"name":"x"}`) is now emitted as bracket notation (`q[name]=x`).
// Several Rails admin endpoints parse their search filter with `JSON.parse(params[:q])`, so they
// expect the JSON-string form — the bracket form makes `JSON.parse` throw, the endpoint rescues
// to `{}`, and the search silently returns everything (see IGN-2359 / IGN-2363).
//
// This is a faithful reproduction of axios 0.16's default param serialisation, so every request
// goes out exactly as it did before the upgrade:
//   - null / undefined -> skipped
//   - array            -> key[]=v1&key[]=v2   (each element serialised in turn)
//   - Date             -> key=<ISO string>
//   - object           -> key=<JSON.stringify(object)>   (the step axios 1.x dropped)
//   - everything else  -> key=value
//
// encode() matches axios 0.16's encoder (leaves @ : $ , [ ] unescaped, uses + for spaces) so the
// emitted URLs are byte-for-byte what the backend received pre-upgrade.

const encode = val => encodeURIComponent(val)
  .replace(/%40/gi, '@')
  .replace(/%3A/gi, ':')
  .replace(/%24/g, '$')
  .replace(/%2C/gi, ',')
  .replace(/%20/g, '+')
  .replace(/%5B/gi, '[')
  .replace(/%5D/gi, ']');

const legacyParamsSerializer = (params) => {
  if (!params) return '';

  const parts = [];

  Object.keys(params).forEach((rawKey) => {
    const value = params[rawKey];

    if (value === null || typeof value === 'undefined') return;

    const isArrayValue = Array.isArray(value);
    const key = isArrayValue ? `${rawKey}[]` : rawKey;
    const values = isArrayValue ? value : [value];

    values.forEach((entry) => {
      let v = entry;

      if (v instanceof Date) {
        v = v.toISOString();
      } else if (v !== null && typeof v === 'object') {
        v = JSON.stringify(v);
      }

      parts.push(`${encode(key)}=${encode(v)}`);
    });
  });

  return parts.join('&');
};

export default legacyParamsSerializer;
